// extracted by mini-css-extract-plugin
export default {"visitsContainer":"styles_visitsContainer__8q5fn","row":"styles_row__jCVd6","visitsTitle":"styles_visitsTitle__KKLdX","visitsValue":"styles_visitsValue__IGSXx"};